export default __webpack_public_path__ + "locales/ar-SA/DataReassignmentDialog.json?hash=3efa89177305e168f85a4253501215df";